import React from 'react';
import './Location.css';
import { trackStoreVisit } from '../utils/analytics';

export default function Location() {
  const latitude = 21.9134408;
  const longitude = 96.0831005;
  
  // Google Maps URLs
  const mapEmbedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3840.2!2d${longitude}!3d${latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjHCsDU0JzQ4LjQiTiA5NsKwMDQnNTkuMiJF!5e0!3m2!1sen!2s!4v1635000000000!5m2!1sen!2s`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;

  return (
    <section className="location-section">
      <div className="location-container">
        <div className="location-header">
          <h2>Visit Our Store</h2>
          <p>Find us in the heart of Mandalay, Myanmar</p>
        </div>

        <div className="location-content">
          <div className="map-container">
            <iframe
              src={mapEmbedUrl}
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kid's Vibes Store Location"
            ></iframe>
          </div>
          
          <div className="directions-container">
            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="directions-btn"
              onClick={() => trackStoreVisit()}
            >
              <span className="directions-text">Navigate to Store</span>
            </a>
          </div>

          <div className="store-notice">
            <p>
              <strong>Please Note:</strong> We recommend contacting us before visiting our store to confirm product availability and ensure we can provide you with the best service during your visit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
